import { AccountObject } from "./account-object.model";
import { Account } from "../account/account.model";
import { RestrictedAccountObject } from "../restricted-account-object/restricted-account-object.model";
import { RestrictedAccountObjectStoreFacade } from "../restricted-account-object/restricted-account-object.store-facade";
import { Observable } from "rxjs/Observable";
import { Category } from "../category/category.model";
import { VasBaseObjectStoreFacade } from "../base-object/vas-base-object-store.facade";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { VasState } from "../../store/store-type";

export abstract class AccountObjectStoreFacade<T extends AccountObject> extends VasBaseObjectStoreFacade<T> {

    getAllByAccount(accountId: string): Observable<Array<T>> {
        const entity = this.getEntity();
        return this.select((state: VasState) => {
            const entityState = state[entity];
            return entityState.ids
                .map(id => entityState.entities[id])
                .filter(object => object.account === accountId);
        });
    }

    removeByAccount(account: Account, options?: ActionOptionsArgs): void {
        this.removeBy(object => object.account === account.id, options);
    }

    protected checkHasDependency<R extends RestrictedAccountObject>(facade: RestrictedAccountObjectStoreFacade<R>, category: Category, dependantEntityName: string): Observable<boolean> {
        return facade
            .getAll()
            .map(items => !items.find(item => item.accessGroup === category.id))
            .map(result => {
                if (!result) {
                    throw new Error(`Cannot delete '${category.title}' because it contains '${dependantEntityName}'. Please delete them first and retry`);
                }
                return result;
            });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-object/account-object.store-facade.ts